import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReportAPI } from "../api/report";
import dayjs from "dayjs";
import ReportLogo from "../assets/SVGs/Report/ReportLogo";
import {
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import PrintReport from "../assets/SVGs/Report/PrintReport";
import Loader from "../componets/Loader";

const MemberActivityReport = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  const fetch = async () => {
    setIsLoading(true);
    try {
      const response = await ReportAPI.getMemberActivityReport(
        localStorage.getItem("report"),
        dayjs().format("YYYY-MM-DD"),
      );
      setData(response.data);
    } catch (e) {
      const status = e.response?.status;
      if (status === 401) {
        navigate("/login");
      }
      console.error("Error during fetching report", e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    isLoading && fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  const modifiedData = data?.map((activity, id) => {
    return { ...activity, id };
  });

  const handlePrint = () => {
    window.print(); // Opens the browser's print dialog
  };

  return isLoading ? (
    <Loader height="100vh" />
  ) : (
    <div className="report-section flex flex-col gap-16">
      <header className="report-header flex align-center justify-between flex-col gap-16">
        <ReportLogo width={122} height={50} />

        <div className="header-section flex align-center justify-between flex-col">
          <h1 className="header-title">Member’s Activity Report</h1>
          <p className="header-date">{`${dayjs(
            localStorage.getItem("report"),
          ).format("MM/DD/YYYY")} - ${dayjs().format("MM/DD/YYYY")}`}</p>
          <IconButton
            sx={{
              border: "1px solid #AEBBCB",
              "@media print": {
                display: "none", // Hides the button during print
              },
            }}
            onClick={handlePrint}
            className="no-print"
          >
            <PrintReport className="no-print" />
          </IconButton>
        </div>
      </header>

      <Stack
        sx={{
          width: "100%",
          "& .MuiTable-root": {
            borderRadius: "8px",
          },
        }}
        className="customTable report-table"
      >
        <TableContainer component={Paper} className="customTable">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>First Name</TableCell>
                <TableCell>Last Name</TableCell>
                <TableCell>Attendance(1)</TableCell>
                <TableCell>Visitors(10)</TableCell>
                <TableCell>Meet-Ups(3)</TableCell>
                <TableCell>Referrals(5)</TableCell>
                <TableCell>Total Points</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {modifiedData?.length > 0 ? (
                modifiedData.map((row, index) => (
                  <TableRow
                    key={row.id}
                    className={index % 2 === 0 ? "bg-gray" : ""}
                  >
                    <TableCell>{row.first_name}</TableCell>
                    <TableCell>{row.last_name}</TableCell>
                    <TableCell>{row.weekly_meet_attendance_points}</TableCell>
                    <TableCell>{row.visitors_brought_points}</TableCell>
                    <TableCell>{row.meetup_points}</TableCell>
                    <TableCell>{row.referrals_given_points}</TableCell>
                    <TableCell>{row.total_points_received}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    No Member found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>
    </div>
  );
};

export default MemberActivityReport;
